import type { BusinessDataV2Type } from '@am3nd-org/pointcraft-types';

import { useDeviceSyncStore } from 'src/store/DeviceSync';

/** Access V2 is the sole admission flag for the offline application shell. */
export function isOfflineModeEnabled(businessData: BusinessDataV2Type | null | undefined): boolean {
  return businessData?.access_v2?.businessAccess?.settings?.system?.offlineModeEnabled === true;
}

export function useOfflineModeEnabled(): boolean {
  return useDeviceSyncStore((state) => isOfflineModeEnabled(state.businessData));
}

export function getCurrentOfflineModeEnabled(): boolean {
  return isOfflineModeEnabled(useDeviceSyncStore.getState().businessData);
}
